import axios from "axios";

var url = window.location.href;
if (window.location.host.startsWith('bsync')) {
  url = 'https://luxury-places.local.host/fr';
} else {
  const match = url.match(/(https?:\/\/[^/]+\/[a-z]{2})(\/|\?|#)/);
  if (match && match.length > 1) {
    url = match[1];
  }
}

export default axios.create({
  baseURL: url + "/lp-search/api",
  headers: {
    "Content-type": "application/json"
  }
});
